import React from 'react'
import SubHeader from '../general/SubHeader';
import Gallery1 from '../assets/gallery/1.jpeg';
import Gallery2 from '../assets/gallery/2.jpeg';
import Gallery3 from '../assets/gallery/3.jpeg';
import Gallery4 from '../assets/gallery/4.jpeg';
import Gallery5 from '../assets/gallery/5.jpeg';
import Gallery6 from '../assets/gallery/6.jpeg';


const Gallery = () => {
    return (
        <>
            <SubHeader message="Gallery" />

            <section className='py-5 bg-light'>
                <div className='container px-lg-5 px-3'>

                    <div className='row'>

                        <div className='col-lg-3 col-md-6 col-6 my-2'>
                            <div className='destination-area'>
                                <img src={Gallery1} className='img-fluid' alt='Gallery' />
                                <div className='destination-content'>
                                    <div className='destination-content-inner'><span className='fw-semibold fs-5'>😍</span></div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-6 my-2'>
                            <div className='destination-area'>
                                <img src={Gallery2} className='img-fluid' alt='Gallery' />
                                <div className='destination-content'>
                                    <div className='destination-content-inner'><span className='fw-semibold fs-5'>😍</span></div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-6 my-2'>
                            <div className='destination-area'>
                                <img src={Gallery3} className='img-fluid' alt='Gallery' />
                                <div className='destination-content'>
                                    <div className='destination-content-inner'><span className='fw-semibold fs-5'>😍</span></div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-6 my-2'>
                            <div className='destination-area'>
                                <img src={Gallery4} className='img-fluid' alt='Gallery' />
                                <div className='destination-content'>
                                    <div className='destination-content-inner'><span className='fw-semibold fs-5'>😍</span></div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-6 my-2'>
                            <div className='destination-area'>
                                <img src={Gallery5} className='img-fluid' alt='Gallery' />
                                <div className='destination-content'>
                                    <div className='destination-content-inner'><span className='fw-semibold fs-5'>😍</span></div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-6 my-2'>
                            <div className='destination-area'>
                                <img src={Gallery6} className='img-fluid' alt='Gallery' />
                                <div className='destination-content'>
                                    <div className='destination-content-inner'><span className='fw-semibold fs-5'>😍</span></div>
                                </div>
                            </div>
                        </div>


                    </div>
                    {/* row ends */}

                </div>
            </section>

        </>
    )
}

export default Gallery
